var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radioBtn"},[_c('el-radio-group',{attrs:{"size":"small"},on:{"change":_vm.defaultChange},model:{value:(_vm.defaul),callback:function ($$v) {_vm.defaul=$$v},expression:"defaul"}},_vm._l((_vm.list),function(item,index){return _c('el-radio-button',{key:index,attrs:{"label":item.label}},[_vm._v(_vm._s(item.value))])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-328ea280","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Denominated/radioBtn.vue
// module id = null
// module chunks = 